module.exports = __webpack_public_path__ + "img/mz_04.ee4807e0.png";